<script>
	import workspaceService from "../../../services/workspace.js";
	import { goto } from "@roxi/routify";
	import { format } from "svelte-i18n";

	let queryString = new URLSearchParams(
		document.location.search.substring(1),
	);
	let token = queryString.get("token");
	let success = false;

	let error;

	let processing = true;

	if (!token) {
		$goto("/login");
	} else {
		workspaceService.validateEmail(token).then((response) => {
			if (response.ok) {
				success = true;
			} else {
				if (response.status == 403) {
					error = $format("page.register.invalid_token");
				}
				if (response.status == 404) {
					error = $format("page.register.token_used");
				}
			}
			processing = false;
		});
	}
</script>
<style>
	.logo-img{
        margin-top: 4px !important;
        height: 48px !important;
        max-width: 176px !important;
    }
</style>
<div class="pt-5 text-center">
	<div class="col-12 col-sm-6 offset-sm-3 text-center card card-outline mt-5 pt-5 pb-5">
		{#if processing}
			<div class="overlay text-center d-flex flex-column align-items-center pt-5 pb-5">
				<i class="fas fa-2x fa-sync-alt fa-spin" />
			</div>
		{:else if !success && !processing}
			<div class="card-header vlsk-red">
				<strong>Error</strong>
			</div>
			<div class="card-body pt-5 text-center">
				{error}
			</div>
		{:else}
			<div class="card-header text-center">
				<img
					src="/img/logo-vulseek-red-with-legend.png"
					alt="Vulseek by Securetia"
					class="brand-image logo-img logo-img-login"
				/>
			</div>
			<div class="card-body pt-5 pb-5 text-start d-flex justify-content-center">
				{$format("page.register.processing_request")}
			</div>
		{/if}
	</div>
</div>
